import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {PortalAuthService} from '@portal-commons/portal-auth.service';
import {KeycloakService} from '@portal-commons/providers/keycloak.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class IsAuthenticatedGuard {
  constructor(
    private auth: PortalAuthService,
    private router: Router,
    private keycloak: KeycloakService,
  ) {}

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.auth.isAuthenticated().pipe(
      map((isAuthenticated: boolean) => {
        if (!isAuthenticated) {
          this.keycloak.login(state.url);
          return false;
        }
        return true;
      }),
      catchError(err => {
        if (err) {
          this.router.navigate(['/login'], {queryParams: {error: err.message}, queryParamsHandling: 'merge'});
        }
        return of(false);
      }),
    );
  }
}
